<template>
  <div class="shipment">
    <rCenterHeader :list="headerMenu">
      <div slot="search">
        <form>
          <Input
            size="large"
            @on-click="search('')"
            @keydown.enter.native.prevent="search('')"
            v-model="params.keywords"
            icon="ios-search"
            :placeholder="$t('fabricLibrary.search')"
            style="width: 380px; color: #081938"
          />
          <Button
            @click="filterClick"
            class="filter"
            size="large"
            type="primary"
          >
            <span class="iconfont iconshaixuan"></span>
            {{ $t("fabricLibrary.filter") }}
          </Button>
        </form>
      </div>
    </rCenterHeader>
    <div class="shipment-list" :style="{ minHeight: 'calc(100vh - 140px)' }">
      <rShipment
        @delShip="delShip"
        :config="item"
        v-for="(item, index) in list"
        :key="index"
      ></rShipment>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <rNull
        v-if="list.length == 0 && spinShow == false"
        imgStyle="width:300px;margin:40px auto"
        titleStyle="font-size:16px;color:#999"
        :title="$t('noResult')"
      ></rNull>
    </div>
    <div
      v-if="total"
      class="common-flex common-justify-center"
      style="margin-top: 20px;padding-bottom: 20px"
    >
      <Page
        :total="total"
        @on-change="changePage"
        :page-size="params.pageSize"
        :page-size-opts="[20, 40, 60, 80]"
        show-total
      >
        <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
      </Page>
    </div>
    <rShipmentFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="filteShow"
    ></rShipmentFilter>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rCenterHeader from "../../components/r-center-header";
import rShipment from "../../components/r-shipment";
import rShipmentFilter from "../../components/r-shipment-filter";
import rNull from "../../components/r-null";

export default {
  name: "shipment",
  data() {
    return {
      total: 0,
      spinShow: false,
      params: {
        keywords: "",
        pageNum: 1,
        pageSize: 20,
        status: ""
      },
      // 列表
      list: [],
      // 显示筛选
      filteShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.shipment")
        }
      ]
    };
  },
  components: {
    rCenterHeader,
    rShipment,
    rShipmentFilter,
    rNull
  },
  mounted() {
    this.getShipping();
  },
  methods: {
    ...mapActions([
      "getShippingAction", //获得发货列表
      "delShippingAction" //删除
    ]),
    // 修改页数
    changePage(e) {
      this.params.pageNum = e;
      this.getShipping();
    },
    // 删除
    delShip(e) {
      this.delShippingAction({ id: e.id }).then(res => {
        if (res.code == 0) {
          this.params.pageNum == 1;
          this.closeFilte();
          this.getShipping();
        }
      });
    },
    // 搜索
    search(e) {
      if (e) {
        this.params = e;
      }
      this.params.pageNum == 1;
      this.closeFilte();
      this.getShipping();
    },
    // 物流列表
    getShipping() {
      this.spinShow = true;
      this.getShippingAction(this.params)
        .then(res => {
          console.log("res", res);
          this.list = res.data;
          this.total = res.total;
        })
        .finally(res => {
          this.spinShow = false;
        });
    },
    // 显示搜搜分类
    filterClick() {
      this.filteShow = true;
    },
    // 关闭搜索分类
    closeFilte() {
      this.filteShow = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.shipment {
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
  .shipment-list {
    width: 1420px;
    // min-height: 100vh;
    margin: 0 auto;
    background: #fff;
    overflow: hidden;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shipment/shipment.vue